export enum TabsetSize {
  Default = 'default',
  Small = 'small',
  Large = 'large'
}
